import React from 'react';
import './PanelActu.css';

function PanelActu({actualite, style}) {
    
    const getDecodedText = (text) => {
        const encodedText = text;
        const decodedText = document.createElement("textarea");
        decodedText.innerHTML = encodedText;
        return decodedText.value;
    }

    
    const goToActus = (value) => {
        window.open(value, "_blank");
    }

    return ( 
        <div className="actu_component" style={style} title={actualite.news_title} onClick={()=>goToActus(actualite.pages_fr_slug)}>
            <img src={actualite.news_medias_picture} alt="" />
            <div style={{display: 'flex', flexDirection: 'column', height: 150,marginLeft: 25, gap: 2}}>
                <span className='actu_title'>{actualite.news_title}</span>
                <div className="line"></div>
                <span style={{fontSize: 14, fontWeight: 'bold', marginBottom: 5, marginTop: 5}}>{actualite.tags_title}</span>
                <span style={{fontSize: 14}}>{getDecodedText(actualite.pages_fr_meta_description)}</span>
            </div>
        </div>
    );
}

export default PanelActu;